module.exports = __webpack_public_path__ + "assets/img/qr.784154e1.jpg";